"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
var TokenPurpose;
(function (TokenPurpose) {
    TokenPurpose["CUSTOMER_SUPPORT_REQUEST_RATING"] = "CUSTOMER_SUPPORT_REQUEST_RATING";
})(TokenPurpose = exports.TokenPurpose || (exports.TokenPurpose = {}));
class Token extends Parse.Object {
    constructor(attributes) {
        super('Token', attributes);
    }
    get token() {
        return this.get('token');
    }
    set token(value) {
        this.set('token', value);
    }
    get expiration() {
        return this.get('expiration');
    }
    set expiration(value) {
        this.set('expiration', value);
    }
    get stillValid() {
        return this.get('stillValid');
    }
    set stillValid(value) {
        this.set('stillValid', value);
    }
    get purpose() {
        return this.get('purpose');
    }
    set purpose(value) {
        this.set('purpose', value);
    }
    get retailer() {
        return this.get('retailer');
    }
    set retailer(value) {
        this.set('retailer', value);
    }
}
exports.Token = Token;
Parse.Object.registerSubclass('Token', Token);
//# sourceMappingURL=Token.js.map